import axios from "axios";
import React, { useState, useEffect } from "react";

const AdminRewards = () => {
  const [rewardHistory, setRewardHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showUpdateStatus, setShowUpdateStatus] = useState(false);
  const [selectedReward, setSelectedReward] = useState(null);
  const [responseMessage, setResponseMessage] = useState(false);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await axios.get(
          `https://api.swalokgroup.com/api/get-reward`
        );
        const data = response.data;
        data.sort((a, b) => new Date(b.reward_date) - new Date(a.reward_date));
        setRewardHistory(data);
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  // const totalRewardAmount = rewardHistory.reduce((total, reward) => total + parseFloat(reward.amount), 0);

  const handleStatus = (reward) => {
    setSelectedReward(reward);
    setShowUpdateStatus(true);
  };

  const handleGiveReward = async (e) => {
    e.preventDefault();
    setResponseMessage("");

    try {
      const response = await axios.put(
        `https://api.swalokgroup.com/api/update-reward`,
        {
          reward_id: selectedReward.reward_id,
        }
      );

      console.log(response);

      if (response.status == 200) {
        setRewardHistory((prevHistory) =>
          prevHistory.map((reward) =>
            reward.reward_id === selectedReward.reward_id
              ? { ...reward, description: 1 }
              : reward
          )
        );
        setResponseMessage("Reward given successfully.");
        setTimeout(() => {
          setResponseMessage("");
          setShowUpdateStatus(false);
        }, 1000);
      } else {
        setResponseMessage("Unable to give reward. Try again later");
        setTimeout(() => {
          setResponseMessage("");
        }, 1000);
      }
    } catch (error) {
      console.error(error.message);
      setResponseMessage("Unable to approve the reward. Try again later");
      setTimeout(() => {
        setResponseMessage("");
      }, 1000);
    }
  };

  return (
    <>
      <section className="py-5">
        <div className="container">
          <div className="sec-subheading">
            <hr />
            <span>My Rewards History</span>
            <hr />
          </div>

          {/* <p className='fw-semibold my-4'>Total Reward Amount ₹{totalRewardAmount.toFixed(2)}</p> */}
          <div className="table-responsive text-center mt-4">
            <table className="w-100 text-capitalize">
              <thead>
                <tr className="bg-light para-text">
                  <th className="py-3 px-2">Member Name</th>
                  <th className="py-3 px-2">Member Id</th>
                  <th className="py-3 px-2">Claimed On</th>
                  <th className="py-3 px-2">Amount</th>
                  <th className="py-3 px-2">Category</th>
                  <th className="py-3 px-2">Status</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="6" className="py-3 px-2">
                      Loading rewards...
                    </td>
                  </tr>
                )}

                {rewardHistory.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="py-3 px-2">
                      No rewards found.
                    </td>
                  </tr>
                ) : (
                  rewardHistory.map((reward) => (
                    <tr className="text-muted para-text" key={reward.id}>
                      <td className="py-3 px-2">{reward.name}</td>
                      <td className="py-3 px-2">{reward.member_clientid}</td>
                      <td className="py-3 px-2">
                        {formatDate(reward.reward_date)}
                      </td>
                      <td className="py-3 px-2">₹{reward.amount}</td>
                      <td className="py-3 px-2 text-capitalize">
                        {reward.rewardCategory} Reward
                      </td>
                      <td
                        className={`py-3 px-2 cursor-pointer ${
                          reward.is_approved === 1
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        {reward.is_approved == 1 &&
                        <i className="fa-solid fa-check-to-slot fs-5"></i>}
                        {reward.is_approved !== 1 && (
                          <span onClick={() => handleStatus(reward)}>
                            &nbsp;
                            <i className="fa-solid fa-pen-to-square fs-5"></i>
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* table ends */}
        </div>
      </section>

      {showUpdateStatus && (
        <>
          <section
            className="popup-area"
            onClick={() => {
              setShowUpdateStatus(false);
              setSelectedReward(null);
            }}
          >
            <div
              className="popup-inner text-center"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="sec-subheading">
                <hr />
                <span>Update Status</span>
                <hr />
              </div>
              <p className="my-4">
                Do you want to approve this reward?
                <br />
                <br />
                Amount: {selectedReward.amount}
                <br />
              </p>

              <button
                className="admin-btn py-2 px-3 rounded"
                type="submit"
                onClick={handleGiveReward}
              >
                Give Reward <i className="fa-solid fa-award"></i>
              </button>
            </div>

            {responseMessage && (
              <div className="response-message d-flex justify-content-between">
                <p className="my-0 mx-auto">{responseMessage}</p>
                <p
                  className="my-0 cursor-pointer"
                  onClick={() => setResponseMessage(false)}
                >
                  <i className="fa-solid fa-xmark"></i>
                </p>
              </div>
            )}
          </section>
        </>
      )}
    </>
  );
};

export default AdminRewards;
